import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_TEXT_LECTURE } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsText } from '@/learnpaths/components/LearnpathsAddElementsText/LearnpathsAddElementsText'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(text)/update/text/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const hasLearnpathTextLectureFeature = useFeatures(
    FEATURE_LEARNPATH_TEXT_LECTURE,
  )

  if (!hasLearnpathTextLectureFeature) {
    return null
  }

  return <LearnpathsAddElementsText mode="update" />
}
